import { ICloudPaymentsWidgetData } from '../types';

interface IParams {
  publicId: string | null;
  invoiceId: string | null;
  description: string | null;
  data: ICloudPaymentsWidgetData | null;
}

export const validateResult = (params: IParams): boolean => {
  const { publicId, invoiceId, description, data } = params;

  return [publicId, invoiceId, description, data].every(Boolean);
};
